<template>
  <div id="v2-course-pay-header" class="head">
    <h1>
      <sup>¥</sup>
      <span>{{ price }}</span>
    </h1>
    <h2>{{ title }}</h2>
  </div>
</template>
<script>
export default {
  name: "V2CoursePayHeader",
  props: ["title", "price"],
}
</script>
